import React from "react";
import { FormattedMessage } from "react-intl";
import * as R from "ramda";
import { Box, Button, Text } from "@chakra-ui/react";

import { isNilOrEmpty } from "utils";
import { PAYOUT, PURCHASE } from "utils/constants";

const nulllIfEmpty = (val) => (isNilOrEmpty(val) ? null : val);

const buttonLabel = {
  [PAYOUT]: "payout",
  payout: "payout",
  [PURCHASE]: "purchase",
  purchase: "purchase",
};

export const buttonLabelByFlow = (flow, formatMessage) => {
  switch (flow) {
    case PAYOUT:
    case "payout":
      return formatMessage({
        defaultMessage: "Use this payout method",
        description: "Button label",
      });
    case PURCHASE:
    case "purchase":
      return formatMessage({
        defaultMessage: "Use this payment method",
        description: "Button label",
      });
    default:
      return formatMessage({
        defaultMessage: "Use this payment method",
        description: "Button label",
      });
  }
};

export const getFinalLabelWithDefault = (flowConfig, defaultMessage) =>
  R.defaultTo(defaultMessage, nulllIfEmpty(R.path(["selectButton", "label"], flowConfig)));

export const getFinalLabel = (flowConfig, flow) =>
  R.defaultTo(
    `Use this ${buttonLabel[flow] || "payment"} method`,
    nulllIfEmpty(R.path(["selectButton", "label"], flowConfig))
  );

export const ChargeWillAppearOnYourStatementAs = ({ chooserConfig = {} }) => {
  if (isNilOrEmpty(chooserConfig.statementDescriptor)) {
    return null;
  }
  const publisherName = chooserConfig.statementDescriptor;
  return (
    <Text data-testid="pm-statement-descriptor" fontSize="xs" color="tertiaryText">
      <FormattedMessage
        defaultMessage="Charge will appear on your statement as {publisherName}"
        description="Charge, as it relates to a money transaction."
        values={{
          publisherName: `"${publisherName}"`,
        }}
      />
    </Text>
  );
};

export const SelectButton = ({ label, disabled, chooserConfig, onClick }) => {
  return (
    <Box>
      <Button
        data-testid="pm-complete-button"
        id="pm-complete-button"
        isDisabled={disabled}
        onClick={onClick}
        width="full"
      >
        {label}
      </Button>
      <ChargeWillAppearOnYourStatementAs chooserConfig={chooserConfig} />
    </Box>
  );
};
